import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutDashboard, Mountain, Zap, BookOpen, Share2, Sparkles, Download, Shield, LogOut, ChevronRight } from 'lucide-react';
import { Drawer, DrawerContent, DrawerTitle } from '../ui/drawer';
import { useAuth } from '../../context/AuthContext';
import { isStandalone } from '../../services/installPrompt';

const ITEMS = [
  { label: 'Tableau de bord', route: '/dashboard', icon: LayoutDashboard, testid: 'sheet-dashboard' },
  { label: 'Accès aux terrains', route: '/land-access', icon: Mountain, testid: 'sheet-land-access' },
  { label: 'Forfaits & abonnements', route: '/pricing', icon: Zap, testid: 'sheet-pricing' },
  { label: 'Pistes de sang communautaires', route: '/blood-tracks', icon: Share2, testid: 'sheet-blood-tracks' },
  { label: 'Nouveautés 2026', route: '/nouveautes-2026', icon: Sparkles, testid: 'sheet-nouveautes' },
  { label: 'Guide des testeurs', route: '/testers-guide', icon: BookOpen, testid: 'sheet-testers-guide' },
];

export const PlusSheet = ({ open, onOpenChange, onInstall }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const go = (route) => { onOpenChange(false); navigate(route); };
  const handleLogout = async () => { onOpenChange(false); await logout(); navigate('/login'); };

  const Row = ({ icon: Icon, label, onClick, testid, variant }) => (
    <button
      data-testid={testid}
      onClick={onClick}
      className={`w-full flex items-center gap-4 px-4 py-3.5 rounded-sm text-left transition-colors active:bg-white/10 ${
        variant === 'danger' ? 'text-red-400 hover:bg-red-500/10' :
        variant === 'highlight' ? 'bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] hover:bg-[#F97316]/20' :
        'text-zinc-200 hover:bg-white/5'
      }`}
    >
      <Icon size={20} />
      <span className="flex-1 text-sm font-semibold uppercase tracking-wider">{label}</span>
      <ChevronRight size={16} className="opacity-40" />
    </button>
  );

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent data-testid="plus-sheet" className="bg-[#18181B] border-white/10 rounded-t-2xl pb-[calc(env(safe-area-inset-bottom)+16px)] max-h-[85vh]">
        <div className="px-4 pt-2 overflow-y-auto">
          <DrawerTitle className="text-xs font-mono uppercase tracking-widest text-orange-500 mb-3 font-bold flex items-center justify-between">
            <span>Plus</span>
            <span className="text-zinc-500 normal-case tracking-normal font-body truncate max-w-[55%]">{user?.name || user?.email}</span>
          </DrawerTitle>
          <div className="flex flex-col gap-1">
            {ITEMS.map((it) => <Row key={it.route} icon={it.icon} label={it.label} onClick={() => go(it.route)} testid={it.testid} />)}
            {!isStandalone() && (
              <Row icon={Download} label="Installer l'application" onClick={() => { onOpenChange(false); onInstall(); }} testid="sheet-install-app" variant="highlight" />
            )}
            {user?.role === 'admin' && <Row icon={Shield} label="Panneau administration" onClick={() => go('/admin')} testid="sheet-admin" />}
            <div className="border-t border-white/10 mt-2 pt-2">
              <Row icon={LogOut} label="Se déconnecter" onClick={handleLogout} testid="sheet-logout" variant="danger" />
            </div>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
